/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Page_Schedule_TitleInputs */

const en_pricing_page_schedule_title = /** @type {(inputs: Pricing_Page_Schedule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The week on your laptop, the day on your phone.`)
};

const pl_pricing_page_schedule_title = /** @type {(inputs: Pricing_Page_Schedule_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik na laptopie, dzień w telefonie.`)
};

/**
* | output |
* | --- |
* | "The week on your laptop, the day on your phone." |
*
* @param {Pricing_Page_Schedule_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const pricing_page_schedule_title = /** @type {((inputs?: Pricing_Page_Schedule_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Page_Schedule_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_pricing_page_schedule_title(inputs)
	return en_pricing_page_schedule_title(inputs)
});